import { Pipe, PipeTransform } from "@angular/core";
import { AccountTypes } from "../_enums/account-types.enum";

@Pipe({
    standalone: true,
    name: "accountType",
})
export class AccountTypePipe implements PipeTransform {
    transform(value: number): string {
        return AccountTypes[value];
    }
}
